module.exports = __webpack_public_path__ + "img/670.7ecf4d0b.png";